import { Component } from '@verndale/core';
import { animate, inView } from 'motion';
import { isReducedMotion, matchMediaQuery } from '../helpers/utils';

class PracticeDetailMasthead extends Component {
  private readonly isReducedMotion: boolean;
  private readonly isTabletLandscape: boolean;

  constructor(el: HTMLElement) {
    super(el);

    this.isReducedMotion = isReducedMotion(el);
    this.isTabletLandscape = matchMediaQuery({ from: 'tabletLandscape' });
    this.setupDefaults_();
  }

  setupDefaults_() {
    this.dom = {
      $el: this.el,
      $container: this.el.querySelector('.practice-detail-masthead__container') as HTMLElement,
      $headline: this.el.querySelector('.practice-detail-masthead__headline span') as HTMLElement,
      $cta: this.el.querySelector('.practice-detail-masthead__cta') as HTMLElement,
      $ctaIcon: this.el.querySelector(
        '.practice-detail-masthead__cta .scroll-button__icon-container'
      ) as HTMLElement
    };

    this.init();
  }

  init() {
    const { $el, $container, $headline, $cta, $ctaIcon } = this.dom;

    if (this.isReducedMotion || !$container) {
      ($el as HTMLElement)?.classList.add('module--reduced-motion');
      return;
    }

    inView(
      $container,
      element => {
        animate(
          element,
          {
            opacity: [0, 1],
            inlineSize: ['50%', '100%']
          },
          {
            duration: 0.5,
            ease: 'easeInOut'
          }
        );

        if ($headline) {
          animate(
            $headline,
            {
              opacity: [0, 1],
              transform: ['translateY(100%)', 'none']
            },
            {
              duration: 0.5,
              ease: 'easeInOut',
              delay: 0.4
            }
          );
        }

        if ($cta) {
          animate(
            $cta,
            {
              opacity: [0, 1]
            },
            {
              duration: 0.3,
              ease: 'easeInOut',
              delay: 0.4
            }
          );
        }

        if ($ctaIcon) {
          animate(
            $ctaIcon,
            {
              scale: [0, 1]
            },
            {
              duration: 0.3,
              ease: 'easeInOut',
              delay: 0.4
            }
          );
        }
      },
      {
        amount: this.isTabletLandscape ? 0.25 : 0.05
      }
    );
  }
}

export default PracticeDetailMasthead;
